import { Injectable } from '@angular/core';

import { ExpedicaoNaoLiberadoSearch } from '../expedicao-nao-liberado-search';
import { ExpedicaoSearch } from '../expedicao-search';

@Injectable({
    providedIn: 'root'
})
export class ExpedicaoCalculoService {

    /** Calcula a quantidade total de volumes previstos dos pedidos da pessoa */
    calcularQuantidadeTotalVolumesPrevistosNaoLiberadosPessoa(entities: ExpedicaoNaoLiberadoSearch[]): number {
        if (!entities) {
            return 0;
        }

        let quantidade = 0;
        entities.forEach(entity => {
            quantidade += entity.quantidadeVolumesPrevistos && !isNaN(entity.quantidadeVolumesPrevistos) ? Number(entity.quantidadeVolumesPrevistos) : 0;
        });

        return quantidade;
    }

    /** Calcula a quantidade total de volumes previstos dos pedidos da pessoa */
    calcularQuantidadeTotalVolumesPrevistosPessoa(pedidoMaster: ExpedicaoSearch, pedidosDetail: ExpedicaoSearch[]): number {
        let quantidade = 0;
        // Pedido Master
        if (pedidoMaster) {
            quantidade += pedidoMaster.quantidadeVolumesPrevistos && !isNaN(pedidoMaster.quantidadeVolumesPrevistos) ? Number(pedidoMaster.quantidadeVolumesPrevistos) : 0;
        }
        // Pedidos Detail
        if (pedidosDetail && pedidosDetail.length > 0) {
            pedidosDetail.forEach(pedidoDetail => {
                quantidade += pedidoDetail.quantidadeVolumesPrevistos && !isNaN(pedidoDetail.quantidadeVolumesPrevistos) ? Number(pedidoDetail.quantidadeVolumesPrevistos) : 0;
            });
        }

        return quantidade;
    }

    /** Calcula a quantidade total de volumes efetivos dos pedidos da pessoa */
    calcularQuantidadeTotalVolumesEfetivosPessoa(pedidoMaster: ExpedicaoSearch, pedidosDetail: ExpedicaoSearch[]): number {
        let quantidade = 0;
        // Pedido Master
        if (pedidoMaster) {
            quantidade += pedidoMaster.quantidadeVolumesEfetivos && !isNaN(pedidoMaster.quantidadeVolumesEfetivos) ? Number(pedidoMaster.quantidadeVolumesEfetivos) : 0;
        }
        // Pedidos Detail
        if (pedidosDetail && pedidosDetail.length > 0) {
            pedidosDetail.forEach(pedidoDetail => {
                quantidade += pedidoDetail.quantidadeVolumesEfetivos && !isNaN(pedidoDetail.quantidadeVolumesEfetivos) ? Number(pedidoDetail.quantidadeVolumesEfetivos) : 0;
            });
        }

        return quantidade;
    }
}
